function helperStringUpperCase (str) {
  return str.toUpperCase()
}

module.exports = helperStringUpperCase
